angular.module('com.vmware.vsphere.client.host')
      .service('hostDataValidationService', [function () {
         var DOMAIN_NAME_REGEX = /^[a-zA-Z0-9]+([\.\-]?[a-zA-Z0-9]+)*\.[a-zA-Z]+(\/(.)+)*$/;
   return {
      isDomainValid:function(domain){
         return DOMAIN_NAME_REGEX.test(domain);
      }
   };
}]);
